import {
  Checkbox,
  Divider,
  FormControl,
  FormErrorMessage,
  FormLabel,
  GridItem,
  Input,
  Select,
  SimpleGrid,
  Text,
  Textarea,
} from "@chakra-ui/react";
import { ErrorType, FormLabelSmall, RegisterType } from "./FormComponents";

const SPAN_TWO = { base: "auto", md: "1 / span 2" };

export const ContactFormLayout: React.FC<{ register: RegisterType; errors: ErrorType; multiRegion?: boolean }> = ({
  register,
  errors,
  multiRegion = false,
}) => (
  <SimpleGrid columns={{ base: 1, md: 2 }} spacing={{ base: 2, md: 4 }} pb={4}>
    <FormControl id="title" gridColumn={SPAN_TWO} isInvalid={!!errors.title}>
      <FormLabelSmall>Title</FormLabelSmall>
      <Select placeholder="Title" {...register("title", { required: true })}>
        <option value="mr">Mr.</option>
        <option value="miss">Miss</option>
        <option value="mrs">Mrs.</option>
        <option value="ms">Ms.</option>
        <option value="dr">Dr.</option>
      </Select>
    </FormControl>

    <FormControl id="firstName">
      <FormLabelSmall>First Name</FormLabelSmall>
      <Input
        {...register("firstName", {
          required: true,
        })}
        borderColor={errors.firstName ? "red" : "inherit"}
      />
    </FormControl>

    <FormControl id="lastName">
      <FormLabelSmall>Last Name</FormLabelSmall>
      <Input
        {...register("lastName", {
          required: true,
        })}
        borderColor={errors.lastName ? "red" : "inherit"}
      />
    </FormControl>

    <FormControl id="postcode">
      <FormLabelSmall>Postcode</FormLabelSmall>
      <Input
        {...register("postcode", {
          required: true,
        })}
        borderColor={errors.postcode ? "red" : "inherit"}
      />
    </FormControl>

    <FormControl id="houseNumber">
      <FormLabelSmall>House Number or Name</FormLabelSmall>
      <Input
        {...register("houseNumber", {
          required: true,
        })}
        borderColor={errors.postcode ? "red" : "inherit"}
      />
    </FormControl>

    <FormControl id="email">
      <FormLabelSmall>Email</FormLabelSmall>
      <Input
        type="email"
        {...register("email", {
          required: true,
        })}
        borderColor={errors.email ? "red" : "inherit"}
      />
    </FormControl>

    <FormControl id="contactNumber">
      <FormLabelSmall>Contact Number</FormLabelSmall>
      <Input
        type="tel"
        {...register("contactNumber", {
          required: true,
        })}
        borderColor={errors.contactNumber ? "red" : "inherit"}
      />
    </FormControl>

    <FormControl id="message" gridColumn={SPAN_TWO} isInvalid={!!errors.message}>
      <FormLabel>Message</FormLabel>
      <Textarea
        {...register("message", {
          maxLength: {
            value: 255,
            message: "Message must not exceed 255 characters",
          },
        })}
      />
      {errors.message && <FormErrorMessage>{errors.message.message}</FormErrorMessage>}
    </FormControl>

    <FormControl id="signUpToEmail" gridColumn={SPAN_TWO}>
      <Checkbox {...register("signUpToEmail")} size="lg">
        <Text fontSize="md">
          Don't miss out on competitive prices and unbeatable offers with Breakfree Holidays by email
        </Text>
      </Checkbox>
    </FormControl>

    <GridItem gridColumn={SPAN_TWO}>
      <Text py={2}>
        We will share your details with the park owner{multiRegion ? "s" : ""}, who will contact you regarding your
        request.
      </Text>
      <Divider />
    </GridItem>
  </SimpleGrid>
);
